import { render, staticRenderFns } from "./PassengersList.vue?vue&type=template&id=7385c972&"
import script from "./PassengersList.vue?vue&type=script&lang=ts&"
export * from "./PassengersList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports